import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';

const CustomToolTip = styled(Tooltip)``;

export default {
    CustomToolTip
}